<template>
  <div>
    <section>
      <div class="carousel-cell">
        <img
          :alt="slideArr[0].alt_text"
          height="460"
          width="850"
          :fetchpriority="fetchPriority"
          :loading="imgLoading"
          :srcset="`
            ${slideArr[0].image}?width=640 640w,
            ${slideArr[0].image}?width=1352 1352w,
            ${slideArr[0].image}?width=850 850w`"
          sizes="
            (min-width: 1200px) 850px,
            (min-width: 768px) 1352px,
            100vw"
          :src="`${slideArr[0].image}?width=850`"
        >
      </div>
      <div class="mag-glass-container">
        <div
          class="mag-glass p-3"
          @click="openModal()"
          @keypress="openModal()"
        >
          <font-awesome-icon icon="search-plus" />
        </div>
      </div>
    </section>
    <transition name="fade">
      <ProductsCarouselModal
        v-if="showModal"
        :slides="slideArr"
        :thumbnails="thumbnails"
        :initial-slide="currentSlide"
        class="products-modal-container"
        @close-modal="closeModal"
      />
    </transition>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import PDPModalImgMixin from '~/mixins/pdp-modal-img';

export default {
  components: {
    FontAwesomeIcon,
    ProductsCarouselModal: () => import('./ProductsCarouselModal.vue'),
  },
  mixins: [
    PDPModalImgMixin,
  ],
  props: {
    images: {
      type: Array,
      default: () => [],
      required: true,
    },
    videos: {
      type: Array,
      default: () => [],
    },
  },
  created() {
    this.fetchPriority = 'high';
    this.imgLoading = 'eager';

    if (typeof window !== 'undefined') {
      const isMobileOnFirstRender = window.matchMedia('(max-width: 767.98px)').matches;

      // make img lazy and change fetch to low when is mobile
      if (isMobileOnFirstRender) {
        this.fetchPriority = 'low';
        this.imgLoading = 'lazy';
      }
    }
  },
};
</script>

<style>
  /* Hide page scrollbars when modal is open
     an: we need it out of the scope of the component */
  .carousel-hide-scroll {
    overflow: hidden;
  }
</style>

<style lang="scss" scoped>
  @import '~/styles/dorado/themes/dorado';
  @import '~/styles/utils/breakpoints';

  .mag-glass-container {
    position: relative;
    float: right;
    z-index: 1;
    cursor: pointer;

    .mag-glass {
      position: absolute;
      right: 100%;
      bottom: 100%;
      transition: transform 0.2s;

      &:hover {
        transform: scale(1.2);
      }

      > svg {
        font-size: 1.5rem;
      }
    }
  }

  .carousel-cell {
    width: 100%;
    height: auto;
    border-radius: 5px;
    position: relative;

    img {
      object-fit: cover;
      width: 100%;
      border: 1px solid $gray-300;
      border-radius: 5px;
      height: auto;
      max-height: 230px;
    }
  }

  @include media-breakpoint-up(md) {
    .carousel-cell img {
      max-height: 450px;
    }
  }

  @include media-breakpoint-up(lg) {
    .carousel-cell img {
      max-height: 490px;
    }
  }

  /* Modal Transition */
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 400ms;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

</style>
